export function getStringFromField(
    field: string | number | undefined,
): string | undefined {
    return field ? field.toString() : undefined;
}
